module.exports = __webpack_public_path__ + "img/mic-off.342fee9e.svg";